module.exports = __webpack_public_path__ + "static/media/tooltip.cce1ac51.svg";